import { render, staticRenderFns } from "./Flashcards.vue?vue&type=template&id=3a1bc524&scoped=true"
import script from "./Flashcards.vue?vue&type=script&lang=js"
export * from "./Flashcards.vue?vue&type=script&lang=js"
import style0 from "./Flashcards.vue?vue&type=style&index=0&id=3a1bc524&prod&scoped=true&lang=css"
import style1 from "./Flashcards.vue?vue&type=style&index=1&id=3a1bc524&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1bc524",
  null
  
)

export default component.exports